import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 14.143 10.018"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--fill-0, #292A2E)",
      d: "M5.303 7.66 12.963 0l1.18 1.178-8.84 8.84L0 4.714l1.178-1.178z"
    }, null, -1)
  ]))]))
}
export default { render: render }